<script lang="ts">import { getVerbiageKey } from "../utils";
import { cfgToThemeCdnPath, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile } from "@infinitro/global";
import { Text } from "@infinitro/text";
import { onDestroy, onMount } from "svelte";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import assets from "../assets";
import StepCard from "./step-card.svelte";
/* assets */
/** Generic/Wild Ape resolve these directly here instead of through the per-brand assets.ts
* dispatch (kept for legacy brands only). */
const useNeutralAssets = $stateUi.vip?.useNeutralAssetPaths ?? false;
const Badge = useNeutralAssets ? cfgToThemeCdnPath("/about-vip/step1.png") : assets.step1;
const Handshake = useNeutralAssets ? cfgToThemeCdnPath("/about-vip/step2.png") : assets.step2;
const Hat = useNeutralAssets ? cfgToThemeCdnPath("/about-vip/step3.png") : assets.step3;
let swiper;
const steps = [
	{
		id: 1,
		img: Badge,
		title: getVerbiageKey("step_1_text"),
		description: getVerbiageKey("step_1_description")
	},
	{
		id: 2,
		img: Handshake,
		title: getVerbiageKey("step_2_text"),
		description: getVerbiageKey("step_2_description")
	},
	{
		id: 3,
		img: Hat,
		title: getVerbiageKey("step_3_text"),
		description: getVerbiageKey("step_3_description")
	}
];
onMount(() => {
	if ($isMobile) {
		swiper = new Swiper(".swiper-container", {
			loop: false,
			spaceBetween: 4,
			centeredSlides: true,
			slidesPerView: 1.3,
			pagination: {
				clickable: true,
				el: ".swiper-pagination",
				renderBullet: (index, className) => {
					return `<span class="${className}"></span>`;
				}
			},
			navigation: true
		});
	}
});
onDestroy(() => {
	if (swiper) {
		swiper.destroy();
	}
});
</script>

<div class="steps-main">
	<div class="title">
		<Text type="title" titleSize="h3">{$t(Verbiage[getVerbiageKey('getting_started')])}</Text>
	</div>
	{#if $isMobile}
		<div class="swiper-container">
			<div class="swiper-wrapper">
				{#each steps as step (step.id)}
					<div class="swiper-slide">
						<StepCard item={step} />
					</div>
				{/each}
			</div>
			<div class="swiper-pagination"></div>
		</div>
	{:else}
		<div class="steps-container">
			{#each steps as step, index}
				<div
					class="step-wrapper {index === 0
						? 'step-inclined-left'
						: index === 2
							? 'step-inclined-right'
							: index === 1
								? 'step-raised'
								: ''}"
				>
					<StepCard item={step} />
				</div>
			{/each}
		</div>
	{/if}
</div>

<style>
	.title {
		margin-bottom: 4rem;
	}

	.steps-main {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
}

	.steps-container {
		position: relative;
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 2rem;
		-moz-column-gap: 5rem;
		     column-gap: 5rem;
}
	@media (min-width: 1024px) {
		.steps-container {
				flex-direction: row;
		}
	}

	.swiper-container {
		width: 100%;
}

	.swiper-wrapper {
		display: flex;
}

	.swiper-slide {
		display: flex;
		justify-content: center;
}

	.swiper-pagination {
		margin-top: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
}

	.step-inclined-left {
		transform: rotate(-10deg);
	}

	.step-inclined-right {
		transform: rotate(10deg);
	}

	.step-raised {
		transform: translateY(-35px);
	}

	@media (max-width: 1024px) {
		.steps-container {
				display: flex;
				width: 100%;
				justify-content: center;
		}

		.step-wrapper {
				display: flex;
				width: 100%;
				flex-direction: column;
				align-items: center;
			transform: none;
		}
	}
</style>
